export default __webpack_public_path__ + "static/Mallory-Book-31ab0b94201cfad83e0559f9602d165b.woff2";